import { action, makeObservable } from 'mobx';
import moment from 'moment';
import { MODO_PARTICIPACAO_ADVOGADO } from '../dominio/ModoParticipacaoAdvogado';
import NomeUtil from '../util/NomeUtil';
import Service from './Service';

export default class SustentacoesService extends Service {
    constructor(props) {
        super(props);

        makeObservable(this, {
            _salvarAlteracoesSequenciaisInscricao: action,
            _ajustarESalvarSequenciaisProcessos: action,
            ordenar: action
        });
    }

    _dataToMoment(data) {
        return moment(data, 'DD-MM-YYYY-HH-mm-ss');
    }

    _atribuirSequencialSustentacaoLimitandoRepeticoes(sustentacoes, sequencial) {
        let sustentacaoAnterior = {
            nome: '',
            regOAB: {
                numero: 0,
                letra: '',
                siglaUf: ''
            }
        };

        let quantidadeSustentacoesSeguidas = 1;

        for (let sustentacao of sustentacoes) {
            if (
                !NomeUtil.comparaNomesAjustandoAcentos(sustentacao.nome, sustentacaoAnterior.nome) ||
                sustentacao.regOAB.numero !== sustentacaoAnterior.regOAB.numero ||
                (sustentacao.regOAB.letra &&
                    sustentacaoAnterior.regOAB.letra &&
                    sustentacao.regOAB.letra !== sustentacaoAnterior.regOAB.letra) ||
                sustentacao.regOAB.siglaUf !== sustentacaoAnterior.regOAB.siglaUf
            ) {
                sustentacaoAnterior = sustentacao;
                sustentacao.sequencial = sequencial++;
                quantidadeSustentacoesSeguidas = 1;
            } else if (quantidadeSustentacoesSeguidas < 3) {
                sustentacaoAnterior = sustentacao;
                sustentacao.sequencial = sequencial++;
                quantidadeSustentacoesSeguidas++;
            }
        }

        for (let sustentacao of sustentacoes) {
            //atribui sequencial para quem ficou sem
            if (!sustentacao.sequencial) {
                sustentacao.sequencial = sequencial++;
            }
        }

        return sequencial;
    }

    _montarSustentacoesOrdenadas(processosComSustentacao) {
        let sustentacoes = [];
        if (processosComSustentacao) {
            for (let processo of processosComSustentacao) {
                for (let pedidoDetalhado of processo.pedidoSustentacaoOral.pedidosDetalhados) {
                    for (let advogado of pedidoDetalhado.advogados) {
                        let sustentacao = advogado;
                        sustentacao.numeroCompleto = processo.processo.numeroCompleto;
                        sustentacao.sessaoId = processo.sessaoId;
                        sustentacao.fasePreferencialSustentacao = processo.processo.permiteSustentacao;
                        sustentacoes.push(sustentacao);
                    }
                }
            }
        }
        //ordena por fasePreferencial e dataSolicitacaoSustentacao
        sustentacoes = sustentacoes.sort((s1, s2) => {
            if (s1.fasePreferencialSustentacao === true && !s2.fasePreferencialSustentacao) {
                return -1;
            }

            if (s2.fasePreferencialSustentacao === true && !s1.fasePreferencialSustentacao) {
                return 1;
            }

            let m1 = this._dataToMoment(s1.dataSolicitacaoSustentacao);
            let m2 = this._dataToMoment(s2.dataSolicitacaoSustentacao);

            if (m1.isSame(m2)) {
                return 0;
            } else {
                return m1.isAfter(m2) ? 1 : -1;
            }
        });
        let sustentacoesComFasePreferencial = sustentacoes.filter(
            (sustentacao) => sustentacao.fasePreferencialSustentacao === true
        );
        let sustentacoesSemFasePreferencial = sustentacoes.filter(
            (sustentacao) => sustentacao.fasePreferencialSustentacao !== true
        );
        //processos com fase preferencial
        let sequencial = this._atribuirSequencialSustentacaoLimitandoRepeticoes(sustentacoesComFasePreferencial, 1);
        //processos sem fase preferencial
        this._atribuirSequencialSustentacaoLimitandoRepeticoes(sustentacoesSemFasePreferencial, sequencial);
        return sustentacoes;
    }

    _salvarAlteracoesSequenciaisInscricao(sustentacoes, promises) {
        for (let sustentacao of sustentacoes) {
            //salva o sequencial da inscrição do advogado caso tenha sido alterado
            if (sustentacao.sequencial !== sustentacao.sequencialPreferencia) {
                promises.push(
                    this.getSessaoApi().salvarSequenciaPreferenciaInscricao(
                        sustentacao.sessaoId,
                        sustentacao.numeroCompleto,
                        sustentacao.regOAB,
                        sustentacao.sequencial.toString()
                    )
                );
                sustentacao.sequencialPreferencia = sustentacao.sequencial;
            }
        }
    }

    _transferirSequenciaisParaProcessos(processosComSustentacao, sustentacoes) {
        for (let processo of processosComSustentacao) {
            let sequencial = null;
            for (let sustentacao of sustentacoes) {
                if (
                    sustentacao.numeroCompleto === processo.processo.numeroCompleto &&
                    (sequencial == null || sustentacao.sequencial < sequencial)
                ) {
                    sequencial = sustentacao.sequencial;
                }
            }
            processo.seqPreferenciaTemp = sequencial;
        }
        //remove campo temporário
        for (let sustentacao of sustentacoes) {
            sustentacao.sequencial = undefined;
        }
    }

    _ajustarESalvarSequenciaisProcessos(processosComSustentacao, promises) {
        let processosComSustentacaoOrdenados = processosComSustentacao
            .slice()
            .sort((p1, p2) => p1.seqPreferenciaTemp - p2.seqPreferenciaTemp);
        let novoSequencial = 1;
        for (let processo of processosComSustentacaoOrdenados) {
            //inicializa campo informacaoProcessoSalaSessao para processo sem
            if (!processo.informacaoProcessoSalaSessao) {
                processo.informacaoProcessoSalaSessao = { sequenciaPreferencia: 0 };
            }
            if (novoSequencial !== processo.informacaoProcessoSalaSessao.sequenciaPreferencia) {
                promises.push(
                    this.getSessaoApi().salvarOuDeletarSequenciaPreferenciaRegimental(
                        processo.sessaoId,
                        processo.processo.numeroCompleto,
                        novoSequencial.toString()
                    )
                );
                processo.informacaoProcessoSalaSessao.sequenciaPreferencia = novoSequencial;
            }

            if (novoSequencial !== processo.pedidoSustentacaoOral.sequencia) {
                processo.pedidoSustentacaoOral.sequencia = novoSequencial;
            }
            processo.seqPreferenciaTemp = undefined;
            novoSequencial++;
        }
    }

    _removerSequenciaisProcessosSemSustentacao(processos, promises) {
        for (let processo of processos) {
            promises.push(
                this.getSessaoApi().salvarOuDeletarSequenciaPreferenciaRegimental(
                    processo.sessaoId,
                    processo.processo.numeroCompleto,
                    null
                )
            );
            processo.informacaoProcessoSalaSessao.sequenciaPreferencia = undefined;
        }
    }

    processosSemPedidoDeParticipacaoPresencial(processosSessao) {
        let processos = [];

        processosSessao.forEach((proc) => {
            if (
                proc.pedidoSustentacaoOral === undefined ||
                proc.pedidoSustentacaoOral.pedidosDetalhados === undefined ||
                !this.temPartipacaoSessao(proc)
            ) {
                processos.push(proc);
            }
        });

        return processos;
    }

    processosComPedidoDeParticipacaoPresencial(processosSessao) {
        let processos = [];

        processosSessao.forEach((proc) => {
            if (
                proc.pedidoSustentacaoOral !== undefined &&
                proc.pedidoSustentacaoOral.pedidosDetalhados !== undefined &&
                this.temPartipacaoSessao(proc)
            ) {
                processos.push(proc);
            }
        });

        return processos;
    }

    findProcessosComPedidoDeParticipacaoVirtual(processosSessao) {
        let processos = [];

        processosSessao.forEach((proc) => {
            if (
                proc.pedidoSustentacaoOral !== undefined &&
                proc.pedidoSustentacaoOral.pedidosDetalhados !== undefined &&
                this.temPartipacaoVirtual(proc)
            ) {
                processos.push(proc);
            }
        });

        return processos;
    }

    temPartipacaoSessao(proc) {
        return !!proc?.pedidoSustentacaoOral?.pedidosDetalhados?.some((pedido) => {
            return pedido.advogados?.some((advogado) => {
                return !!(
                    advogado.modoParticipacao &&
                    advogado.modoParticipacao !== MODO_PARTICIPACAO_ADVOGADO.VIRTUAL.codigo &&
                    advogado.modoParticipacao !== MODO_PARTICIPACAO_ADVOGADO.SUSTENTACAO_ORAL_ELETRONICA.codigo
                );
            });
        });
    }

    temPartipacaoVirtual(proc) {
        return !!proc?.pedidoSustentacaoOral?.pedidosDetalhados?.some((pedido) => {
            return pedido.advogados?.some((advogado) => {
                return !!(
                    advogado.modoParticipacao === MODO_PARTICIPACAO_ADVOGADO.VIRTUAL.codigo ||
                    advogado.modoParticipacao === MODO_PARTICIPACAO_ADVOGADO.SUSTENTACAO_ORAL_ELETRONICA.codigo
                );
            });
        });
    }

    async ordenar(processos) {
        let processosComSustentacao = this.processosComPedidoDeParticipacaoPresencial(processos);

        let sustentacoes = this._montarSustentacoesOrdenadas(processosComSustentacao);

        let promises = [];
        this._salvarAlteracoesSequenciaisInscricao(sustentacoes, promises);

        //1a ordenação - pode gerar buracos devido a processos com mais de uma sustentação
        this._transferirSequenciaisParaProcessos(processosComSustentacao, sustentacoes);
        //2a ordenação - removendo buracos
        this._ajustarESalvarSequenciaisProcessos(processosComSustentacao, promises);

        //apagar sequencial de processos sem sustentacao
        let processosSemSustentacao = this.processosSemPedidoDeParticipacaoPresencial(processos);
        this._removerSequenciaisProcessosSemSustentacao(processosSemSustentacao, promises);

        await Promise.all(promises);
        return promises.length;
    }
}
